<template>
  <v-expansion-panels v-if="isParent" flat :value="0">
    <v-expansion-panel>
      <v-expansion-panel-header
        class="grey lighten-5 permission-row"
        style="min-height: inherit;"
      >
        {{ permissionRow.title }}
      </v-expansion-panel-header>
      <v-divider />
      <v-expansion-panel-content eager>
        <permission-row
          v-for="subItem in permissionRow.children"
          :key="`${subItem.kind}-${subItem.id}`"
          v-model="selectedPermissions"
          :crud-suffixes="crudSuffixes"
          :permission-row="subItem"
          :readonly="readonly"
          sub
          @check-parent="checkChildren"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

  <div v-else class="permission-row">
    <v-row dense>
      <v-col cols="5" class="py-0">
        <div :class="{ 'pl-7': sub }" @click="selectAllCheckboxes()">
          <v-checkbox
            :id="`form-checkbox-select-row-${permissionRow.id}`"
            v-model="isSelectedAll"
            :value="true"
            :disabled="validPermissionsCount === 0"
            :true-value="true"
            class="pl-2 py-0 pr-0 ma-0"
            readonly
            hide-details
            :false-value="false"
          >
            <template #label>
              <v-subheader class="px-0">
                {{ permissionRow.title }}
              </v-subheader>
            </template>
          </v-checkbox>
        </div>
      </v-col>
      <v-col cols="7">
        <v-row no-gutters align="center" justify="space-around">
          <div
            v-for="(permission, suffix) in permissions"
            :key="suffix"
            :title="trans.crudSuffix(suffix)"
          >
            <v-checkbox
              v-if="!!permission.id"
              :id="`form-checkbox-select-${permissionRow.id}-${suffix}`"
              v-model="selectedPermissions[permission.id]"
              hide-details
              width="50"
              class="my-1"
              :readonly="readonly"
              :true-value="true"
              :false-value="false"
              :title="trans.crudSuffix(suffix)"
              @change="checkViewingPermission(permission)"
            />
            <div v-else style="width: 32px;" />
          </div>
        </v-row>
      </v-col>
    </v-row>

    <v-divider />
  </div>
</template>
<script>
import { each, filter } from "lodash";
import EventBus from "@/utils/EventBus";
export default {
  name: "PermissionRow",

  props: {
    value: {
      type: Object,
      required: true
    },
    permissionRow: {
      required: true,
      type: Object
    },
    sub: {
      type: Boolean,
      default: false
    },
    crudSuffixes: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isAllSelected: false,
      validPermissionsCount: 0,
      permissions: {}
    };
  },

  computed: {
    trans() {
      return { crudSuffix: suffix => this.$t(`Common.crud.${suffix}`) };
    },

    selectedPermissions: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },

    isSelectedAll() {
      let isSelected = true;
      const selected = this.selectedPermissions;
      each(this.permissions, p => {
        if (!isSelected) return;
        if (p.id) isSelected = selected[p.id] === true;
      });
      return isSelected;
    },

    viewPermission() {
      return this.permissions["view"];
    },

    isParent() {
      return (
        this.permissionRow.children && this.permissionRow.children.length > 0
      );
    }
  },

  created() {
    EventBus.$on("select-permission-column", this.selectBySuffix);
    this.mapPermissions();
  },

  methods: {
    mapPermissions() {
      const { crudSuffixes, permissionRow } = this;
      let permissions = {};
      crudSuffixes.forEach(suffix => {
        const perm = permissionRow.permissions.find(
          p => p.permission == suffix
        );
        if (perm) {
          this.validPermissionsCount++;
        }
        permissions[suffix] = perm || {};
      });
      this.permissions = permissions;
    },

    checkChildren() {
      Object.values(this.permissions).forEach(perm => {
        this.$set(this.selectedPermissions, perm.id, false);
      });
      (this.permissionRow?.children || []).forEach(item => {
        (item.permissions || []).forEach(perm => {
          if (this.selectedPermissions[perm.id]) {
            const permId = this.permissions[perm.permission].id;
            this.$set(this.selectedPermissions, permId, true);
          }
        });
      });
    },

    selectAllCheckboxes() {
      if (this.readonly) return;
      const { isSelectedAll } = this;
      each(this.permissions, p => {
        if (p.id) this.$set(this.selectedPermissions, p.id, !isSelectedAll);
      });
      this.emitParent();
    },

    selectBySuffix({ suffix, value }) {
      const permission = this.permissions[suffix];
      if (permission.id) {
        this.$set(this.selectedPermissions, permission.id, value);
        this.checkViewingPermission(permission);
      }
    },

    // Проверить view привелегию ибо нельзя просто взять и поставить (edit, delete, add) без view привелегии
    checkViewingPermission({ id }) {
      const { selectedPermissions, viewPermission, permissions } = this;
      const isSelected = selectedPermissions[id] === true;
      const isSetViewingPermission =
        selectedPermissions[viewPermission.id] === true;
      const isViewingPermission = viewPermission.id === id;
      const otherSelectedPermissions = filter(permissions, perm => {
        return (
          selectedPermissions[perm.id] === true && viewPermission.id != perm.id
        );
      });
      if (isSelected && !isSetViewingPermission) {
        this.$set(selectedPermissions, viewPermission.id, true);
      }
      if (
        isViewingPermission &&
        !isSetViewingPermission &&
        otherSelectedPermissions.length > 0
      ) {
        this.$nextTick(() => {
          this.$set(selectedPermissions, viewPermission.id, true);
        });
      }
      this.emitParent();
    },

    emitParent() {
      if (
        this.permissionRow.parent_id > 0 &&
        this.permissionRow.kind === "realm_class_link"
      ) {
        this.$emit("check-parent");
      }
    }
  }
};
</script>
